import styled from "@emotion/styled";
import { Box } from "@otrium/core";
import BaseButton from "src/atoms/Button/BaseButton";
import { Button } from "src/atoms/Button";

const StyledTopSection = styled.div<{
  url: string;
}>`
  height: 480px;
  min-width: 100%;
  background-image: url(${({ url }) => url});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    height: 640px;
    background-image: url(${({ url }) => url});
  }
  @media (min-width: ${({ theme }) =>
      theme.breakpoints[4]}) and (min-height: ${({ theme }) =>
      theme.breakpoints[2]}) {
    background-position: center top;
  }

  :before {
    content: "";
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 240px;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
    @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
      height: 320px;
    }
  }
`;

const BlackGradient = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.tone.black};
  height: 224px;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    height: 251px;
  }
`;

const StyledTopSectionContent = styled.div`
  position: relative;
  z-index: 2;
  padding-top: 192px;
  text-align: center;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding-top: 224px;
  }
`;

const StyledBrandLogo = styled.img`
  max-width: 352px;
  margin-bottom: ${({ theme }) => theme.space[2]}px;
`;

const StyledTitle = styled.h1`
  font-size: 40px;
  letter-spacing: 1.8px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.tone.white};
  text-transform: uppercase;
  margin-bottom: 16px;
`;

const StyledSocialButtonsContainer = styled.div`
  display: flex;
  & > * {
    margin-right: 0 !important;
    flex: 1 !important;
    margin-top: 8px !important;

    &:not(:first-of-type) {
      margin-left: ${({ theme }) => theme.space[2]}px;
    }
  }

  button {
    background-color: ${({ theme }) => theme.colors.tone.white};
    border-radius: 4px;

    :hover {
      background-color: ${({ theme }) => theme.colors.tone.white};
    }
  }
`;

const StyledGenderIdButton = styled(BaseButton)<{
  active: boolean;
  marginLeft: boolean;
}>`
  flex: 1;
  height: 48px;
  background-color: transparent;
  margin-left: ${({ marginLeft }) => (marginLeft ? "8px" : "0")};
  border: solid 2px ${({ theme }) => theme.colors.tone.white};
  cursor: pointer;
  border-radius: 4px;

  color: ${({ theme }) => theme.colors.tone.white};
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: 600;
  text-transform: capitalize;

  ${({ active, theme }) =>
    active &&
    `
    background-color: ${theme.colors.tone.white};
    color: ${theme.colors.tone.black};
  `}
`;

const StyledButtonWrapper = styled.div`
  button {
    &:not(:disabled) {
      /* TODO: Remove color overwrite after "Gold" variant will be added to the Buttom atom */
      background-color: ${({ theme }) => theme.colors.primary.gold};
      border-color: ${({ theme }) => theme.colors.primary.gold};
    }
  }
`;

const StyledLoginLink = styled.a`
  color: ${({ theme }) => theme.colors.tone.white};
  text-decoration: underline;
  font-weight: 600;
`;

const SeoBottomTextWrapper = styled(Box)`
  h1 {
    color: ${({ theme }) => theme.colors.tone.white};
    font-size: ${({ theme }) => theme.fontSizes[4]}px;
    font-family: Charter;
    line-height: 1.5;
    letter-spacing: normal;
    margin-bottom: ${({ theme }) => theme.space[3]}px;
  }
  h2,
  h3 {
    color: ${({ theme }) => theme.colors.tone.white};
    font-size: ${({ theme }) => theme.fontSizes[3]}px;
    font-family: Charter;
    line-height: 2;
    letter-spacing: normal;
    margin-bottom: ${({ theme }) => theme.space[2]}px;
    text-transform: none;
  }
  p {
    font-family: SourceSansPro;
    line-height: 2;
    letter-spacing: 0.4px;
    color: ${({ theme }) => theme.colors.tone.anthraciteLight};
    margin-bottom: ${({ theme }) => theme.space[5]}px;
  }
`;

const StyledRegisterButton = styled(Button)`
  background: ${({ theme }) => theme.colors.tone.anthraciteLight}; 
  
  &:hover { background-color: "${({ theme }) =>
    theme.colors.tone.anthraciteLight}; },
`;

export {
  StyledTopSection,
  StyledTopSectionContent,
  StyledBrandLogo,
  StyledTitle,
  StyledSocialButtonsContainer,
  StyledGenderIdButton,
  StyledButtonWrapper,
  StyledLoginLink,
  BlackGradient,
  SeoBottomTextWrapper,
  StyledRegisterButton,
};
